export default __webpack_public_path__ + "static/media/background3.83a840c0.svg";